<template>
  <section class="image-text-wrapper">
    <div
      class="image-text-container"
      :style="{
        backgroundImage: `url(${configDataForm.backGroundImageFullUrl || noUpload})`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <header class="title">
        <figure class="title-icon">
          <img
            :src="iconFileFullUrl || noUpload"
            alt="标题图标"
            loading="lazy"
          />
        </figure>
        <h2
          class="title-text"
          :style="{
            color: configDataForm.fontColor,
          }"
        >
          {{ configDataForm.title }}
        </h2>
      </header>
      <div class="content">
        <div class="content-left">
          <article
            class="content-left-top"
            role="article"
            aria-label="左上卡片"
          >
            <figure class="content-image">
              <img
                :src="contentDataInfo.leftTopImageObj?.url || noUpload"
                :alt="contentDataInfo.leftTopTitle"
                loading="lazy"
              />
            </figure>
            <div
              class="content-text"
              :style="{
                'background-color': contentDataInfo.leftTopBackgroundColor,
              }"
            >
              <h3 class="text-title">
                {{ contentDataInfo.leftTopTitle }}
              </h3>
              <p class="text-sub-title">
                {{ contentDataInfo.leftTopSubTitle }}
              </p>
            </div>
          </article>
          <article
            class="content-left-bottom"
            role="article"
            aria-label="左下卡片"
          >
            <figure class="content-image">
              <img
                :src="contentDataInfo.leftBottomImageObj?.url || noUpload"
                :alt="contentDataInfo.leftBottomTitle"
                loading="lazy"
              />
            </figure>
            <div
              class="content-text"
              :style="{
                'background-color': contentDataInfo.leftBottomBackgroundColor,
              }"
            >
              <h3 class="text-title">
                {{ contentDataInfo.leftBottomTitle }}
              </h3>
              <p class="text-sub-title">
                {{ contentDataInfo.leftBottomSubTitle }}
              </p>
            </div>
          </article>
        </div>
        <article class="content-right" role="article" aria-label="右侧卡片">
          <figure class="content-image">
            <img
              :src="contentDataInfo.rightImageObj?.url || noUpload"
              :alt="contentDataInfo.rightTitle"
              loading="lazy"
            />
          </figure>
          <div
            class="content-text"
            :style="{
              'background-color': contentDataInfo.rightBackgroundColor,
            }"
          >
            <h3 class="text-title">
              {{ contentDataInfo.rightTitle }}
            </h3>
            <p class="text-sub-title">
              {{ contentDataInfo.rightSubTitle }}
            </p>
          </div>
        </article>
      </div>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <image-text-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></image-text-edit-form>
    </el-drawer>
  </section>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import ImageTextEditForm from './ImageTextEditFormFifteen.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props-configDataForm:',props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

// 表单绑定对象
const configDataForm = ref({
  contentImageObj: null,
  imageName: '',
  imageFileKey: 'contentImage',
  backGroundImageObj: null,
  backgroundImageName: '',
  backgroundImageFileKey: 'backgroundImage',
  title: '示例标题',
  content: '示例内容',
  textColor: '#ffffff',
  backgroundColor: '#008bd5',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
}

// 图标
const iconFileFullUrl = computed(() => {
  return configDataForm.value ? configDataForm.value.iconFullUrl : '';
});

// 图标
const contentDataInfo = computed(() => {
  const contentData = {
    backGroundImageObj: null,
    backgroundImageName: '',
    backgroundImageFileKey: 'backgroundImage',
    backgroundColor: '#008bd5',
    title: '示例标题',
    fontColor: '#ffffff',
    iconImageObj: null,
    iconName: '示例图标1.png',
    iconFileKey: 'iconImage',
    leftTopImageObj: null,
    leftTopImageName: '示例图标1.png',
    leftTopImageFileKey: 'itemFile1',
    leftTopTitle: '信息门户',
    leftTopSubTitle: '信息门户',
    leftTopBackgroundColor: '#DBC283',
    leftTopLinkUrl: 'https://www.baidu.com',
    leftBottomImageObj: null,
    leftBottomImageName: '示例图标1.png',
    leftBottomImageFileKey: 'itemFile2',
    leftBottomTitle: '信息门户',
    leftBottomSubTitle: '信息门户',
    leftBottomBackgroundColor: '#75A5CF',
    leftBottomLinkUrl: 'https://www.baidu.com',
    rightImageObj: null,
    rightImageName: '示例图标1.png',
    rightImageFileKey: 'itemFile3',
    rightTitle: '信息门户',
    rightSubTitle: '信息门户',
    rightBackgroundColor: '#4EACA2',
    rightLinkUrl: 'https://www.baidu.com',
  };

  if (configDataForm.value.items && configDataForm.value.items.length > 0) {
    // 左上
    const leftTopItem = configDataForm.value.items[0];
    contentData.leftTopImageObj = {
      name: leftTopItem.itemFileName,
      url: leftTopItem.itemFileFullUrl,
    };
    contentData.leftTopImageName = leftTopItem.itemFileName;
    contentData.leftTopTitle = leftTopItem.title;
    contentData.leftTopSubTitle = leftTopItem.subTitle;
    contentData.leftTopLinkUrl = leftTopItem.linkUrl;
    contentData.leftTopBackgroundColor =
      leftTopItem.backgroundColor || '#DBC283';
    // 左下
    const leftBottomItem = configDataForm.value.items[1];
    contentData.leftBottomImageObj = {
      name: leftBottomItem.itemFileName,
      url: leftBottomItem.itemFileFullUrl,
    };
    contentData.leftBottomImageName = leftBottomItem.itemFileName;
    contentData.leftBottomTitle = leftBottomItem.title;
    contentData.leftBottomSubTitle = leftBottomItem.subTitle;
    contentData.leftBottomLinkUrl = leftBottomItem.linkUrl;
    contentData.leftBottomBackgroundColor =
      leftBottomItem.backgroundColor || '#75A5CF';
    // 右边
    const rightItem = configDataForm.value.items[2];
    contentData.rightImageObj = {
      name: rightItem.itemFileName,
      url: rightItem.itemFileFullUrl,
    };
    contentData.rightImageName = rightItem.itemFileName;
    contentData.rightTitle = rightItem.title;
    contentData.rightSubTitle = rightItem.subTitle;
    contentData.rightLinkUrl = rightItem.linkUrl;
    contentData.rightBackgroundColor = rightItem.backgroundColor || '#4EACA2';
  }

  return contentData;
});

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>

<style scoped lang="scss">
// [PC端优化-2026-03-10] 统一设计变量
$radius-md: 8px;
$radius-lg: 12px;
$shadow-sm: 0 2px 8px rgb(0 0 0 / 6%);
$shadow-md: 0 4px 12px rgb(0 0 0 / 8%);
$shadow-lg: 0 8px 24px rgb(0 0 0 / 12%);
$shadow-hover: 0 12px 32px rgb(0 0 0 / 16%);
$transition-normal: 0.35s cubic-bezier(0.4, 0, 0.2, 1);

@media screen and (width >= 1181px) {
  .image-text-wrapper {
    width: 100%;
  }

  .image-text-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: self-start;
    justify-content: center;
    width: 100%;
    // [侧边距调整-2026-03-08] 100px → 80px
    padding: 0 80px;

    .title {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      height: 60px;
      padding-bottom: 20px;
      border-bottom: 1px solid #cfd0c5;

      .title-icon {
        width: 40px;
        height: 40px;
        padding: 0;
        margin: 0 20px 0 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: $radius-md;
        }
      }

      .title-text {
        flex-grow: 1;
        height: 40px;
        margin: 0 0 20px;
        font-size: 36px;
        font-weight: 600;
        line-height: 40px;
      }
    }

    .content {
      display: flex;
      flex-grow: 1;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .content-left {
        display: flex;
        flex-direction: column;
        // [间距调整-2026-03-08] 20px → 30px
        gap: 30px;
        width: 680px;
        padding-top: 20px;
        padding-right: 20px;

        .content-left-top,
        .content-left-bottom {
          display: flex;
          flex-direction: column;
          width: 100%;
          overflow: hidden;
          background: #fff;
          border-radius: $radius-lg;
          box-shadow: $shadow-md;
          transition: all $transition-normal;

          &:hover {
            box-shadow: $shadow-hover;
            transform: translateY(-4px);

            .content-image img {
              transform: scale(1.05);
            }
          }
        }

        .content-image {
          position: relative;
          width: 100%;
          height: 240px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform $transition-normal;
          }
        }

        .content-text {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          width: 100%;
          height: 120px;
          padding: 20px 40px;
          color: #fff;

          .text-title {
            margin: 0;
            font-size: 24px;
            font-weight: bold;
          }

          .text-sub-title {
            display: -webkit-box;
            margin: 0;
            overflow: hidden;
            font-size: 20px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }

      .content-right {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: space-evenly;
        margin-top: 20px;
        overflow: hidden;
        color: #fff;
        background: #fff;
        border-radius: $radius-lg;
        box-shadow: $shadow-md;
        transition: all $transition-normal;

        &:hover {
          box-shadow: $shadow-hover;
          transform: translateY(-4px);

          .content-image img {
            transform: scale(1.05);
          }
        }

        .content-image {
          position: relative;
          width: 100%;
          height: 500px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform $transition-normal;
          }
        }

        .content-text {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          width: 100%;
          height: 240px;
          padding: 20px 40px;
          color: #fff;

          .text-title {
            margin: 0;
            font-size: 24px;
            font-weight: bold;
          }

          .text-sub-title {
            display: -webkit-box;
            margin: 0;
            overflow: hidden;
            font-size: 20px;
            line-height: 40px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
/* [移动端优化-2026-03-10] 基于设计四大原则 */
@media screen and (width <= 1180px) {
  .image-text-wrapper {
    width: 100%;
  }

  .image-text-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 4vw;
    background-color: #fff;

    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: auto;
      padding-bottom: 4vw;

      .title-icon {
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0;
        margin: 0;
        font-size: 7.5vw;

        img {
          width: 7.5vw;
          height: 7.5vw;
          margin-right: 2vw;
          object-fit: contain;
          // [灵动-2026-03-11] 标题图标脉动发光（与ColumnContentSix保持一致）
          animation: iconGlow 2s ease-in-out infinite;
        }
      }

      .title-text {
        flex-grow: 1;
        overflow: hidden;
        margin: 0;
        font-size: 5vw;
        font-weight: 600;
        line-height: 1.4;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .content {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 92vw;

      .content-left {
        display: flex;
        flex-direction: row;
        gap: 2vw;
        width: 92vw;

        .content-left-top,
        .content-left-bottom {
          display: flex;
          flex: 1;
          flex-direction: column;
          overflow: hidden;
          background: #fff;
          border-radius: 3vw;
          box-shadow: 0 2px 12px rgb(0 0 0 / 8%);
          // [灵动-2026-03-10] 入场动画
          opacity: 0;
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          animation: fadeInUp 0.4s ease-out forwards;

          // [灵动-2026-03-10] 错落延迟
          &.content-left-top {
            animation-delay: 0.1s;
          }
          &.content-left-bottom {
            animation-delay: 0.2s;
          }

          // [灵动-2026-03-10] 触摸缩放 + 阴影增强
          &:active {
            box-shadow: 0 4px 20px rgb(0 0 0 / 15%);
            transform: scale(0.97);
          }
        }

        .content-image {
          position: relative;
          width: 100%;
          height: 33vw;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            // [灵动-2026-03-10] 图片过渡
            transition: transform 0.35s ease;
          }
        }

        // [灵动-2026-03-10] 触摸时图片放大
        .content-left-top:active .content-image img,
        .content-left-bottom:active .content-image img {
          transform: scale(1.05);
        }

        .content-text {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          width: 100%;
          height: 28vw;
          padding: 4vw;
          color: #fff;

          .text-title {
            // [灵动-2026-03-10] 下划线效果
            position: relative;
            display: inline-block;
            margin: 0;
            font-size: 3.5vw;
            font-weight: bold;

            &::after {
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 0;
              height: 2px;
              content: '';
              background: rgb(255 255 255 / 50%);
              transition: width 0.3s ease;
            }
          }

          .text-sub-title {
            display: -webkit-box;
            margin: 0;
            overflow: hidden;
            font-size: 3vw;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }

        // [灵动-2026-03-10] 触摸时标题下划线展开
        .content-left-top:active .content-text .text-title::after,
        .content-left-bottom:active .content-text .text-title::after {
          width: 100%;
        }
      }

      .content-right {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: space-evenly;
        margin-top: 4vw;
        overflow: hidden;
        color: #fff;
        background: #fff;
        border-radius: 3vw;
        box-shadow: 0 2px 12px rgb(0 0 0 / 8%);
        // [灵动-2026-03-10] 入场动画
        opacity: 0;
        transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        animation: fadeInUp 0.4s ease-out forwards;
        animation-delay: 0.3s;

        // [灵动-2026-03-10] 触摸缩放 + 阴影增强
        &:active {
          box-shadow: 0 4px 20px rgb(0 0 0 / 15%);
          transform: scale(0.98);
        }

        .content-image {
          position: relative;
          width: 92vw;
          height: 52vw;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            // [灵动-2026-03-10] 图片过渡
            transition: transform 0.35s ease;
          }
        }

        // [灵动-2026-03-10] 触摸时图片放大
        &:active .content-image img {
          transform: scale(1.05);
        }

        .content-text {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          width: 92vw;
          height: 44vw;
          padding: 5vw;
          color: #fff;

          .text-title {
            // [灵动-2026-03-10] 下划线效果
            position: relative;
            margin: 0;
            font-size: 3.5vw;
            font-weight: bold;

            &::after {
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 0;
              height: 2px;
              content: '';
              background: rgb(255 255 255 / 50%);
              transition: width 0.3s ease;
            }
          }

          .text-sub-title {
            display: -webkit-box;
            margin: 0;
            overflow: hidden;
            font-size: 3vw;
            line-height: 8vw;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        // [灵动-2026-03-10] 触摸时标题下划线展开
        &:active .content-text .text-title::after {
          width: 100%;
        }
      }
    }
  }
}
</style>
